export const TYPE_SELECTION: any[] = [
	{ value: 'character', icon: 'face', color: 'blue', propertyName: 'cast_name', categoryId: 'cast_category_id', list: 'characters', visible: true },
	{ value: 'element', icon: 'fact_check', color: 'yellow', propertyName: 'element_name', categoryId: 'category_id', list: 'elements', visible: true },
	{ value: 'extra', icon: 'supervised_user_circle', color: 'green', propertyName: 'extra_name', list: 'extras', visible: true },
	{ value: 'note', icon: 'sticky_note_2' },
	// { value: 'vfx', icon: 'blur_on' },
	{ value: 'add', icon: 'add' },
];